import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import { DFPSlotsProvider, AdSlot, Size } from 'react-dfp/lib';
import breakpoints from '../Theme/breakpoints';

export const SideBarAdUnitContainer = styled.div`
  display: none;

  @media (min-width: ${breakpoints.xssm}px) {
    display: block;
  }
`;

const adUnitContainerPropertyTypes = {
  height: PropTypes.string,
  minHeight: PropTypes.string,
};

type AdUnitContainerPropertyTypes = InferProps<
  typeof adUnitContainerPropertyTypes
>;

const AdUnitContainer = styled.div<AdUnitContainerPropertyTypes>`
  height: ${(properties) => properties.height};
  min-height: ${(properties) => properties.minHeight};
  border: 1px solid ${({ theme }) => theme.colors.greyLight};
  text-align: center;
  text-align: -webkit-center;
  padding: 24px 0;

  @media (min-width: ${breakpoints.sm}px) {
    border: none;
  }

  @media (min-width: ${breakpoints.md}px) {
    padding: 16px 0;
  }

  iframe {
    display: block;
    margin: 0 auto;
  }
`;

AdUnitContainer.propTypes = adUnitContainerPropertyTypes;

const adUnitPropertyTypes = {
  dfpNetworkId: PropTypes.string.isRequired,
  adUnit: PropTypes.string.isRequired,
  sizes: PropTypes.arrayOf(PropTypes.node),
  height: PropTypes.string,
  minHeight: PropTypes.string.isRequired,
};

type AdUnitPropertyTypes = InferProps<typeof adUnitPropertyTypes> & {
  sizes?: Size[];
};

const AdUnit = ({
  dfpNetworkId,
  adUnit,
  sizes,
  height,
  minHeight,
}: AdUnitPropertyTypes) => (
  <AdUnitContainer
    height={height}
    minHeight={minHeight}
  >
    <DFPSlotsProvider
      dfpNetworkId={dfpNetworkId}
      adUnit={adUnit}
    >
      <AdSlot sizes={sizes ?? []} />
    </DFPSlotsProvider>
  </AdUnitContainer>
);

AdUnit.propTypes = adUnitPropertyTypes;

export default AdUnit;
